import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import { useLang } from "@/contexts/LanguageContext";
import useSeo from "@/hooks/useSeo";

export default function BlogPage() {
  useSeo({
    title: "Ride Log — Bike & E-Bike Journal",
    description: "Trails in North Macedonia, e-bike guides, product reviews, and maintenance tips — from the VELOTEKA workshop.",
    path: "/blog",
  });
  const { t } = useLang();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="blog-page">
      <div className="mb-12">
        <div className="overline text-[color:var(--vt-orange)] mb-3">/ THE JOURNAL</div>
        <h1 className="font-display font-black text-6xl md:text-7xl tracking-tighter">Ride Log</h1>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="group no-underline-link" data-testid={`blog-item-${post.slug}`}>
            <div className="aspect-[4/3] overflow-hidden mb-4">
              <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="overline text-[color:var(--vt-orange)] mb-2">{post.category}</div>
            <h3 className="font-display font-black text-2xl tracking-tighter mb-2 group-hover:text-[color:var(--vt-orange)] transition-colors">{post.title}</h3>
            <p className="text-neutral-600 text-sm mb-2">{post.excerpt}</p>
            <div className="text-xs text-neutral-500">By {post.author}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
